import { Col, Row } from "reactstrap";
import Collapsable from "../../../components/Collapsable";
import DataTableNested from "../../../components/DataTableNested";

const QuoteOverviewFinancialTable = ({header, quoteItems, columns}) => {

    const generateFooter = () => {
        if (quoteItems.length === 0) return null;

        // This function is used to render each cell in the footer row.
        // It is similar to the render logic used in DataTableNested for cells,
        // but with some differences (bold font, top border, no inner DIV)

        const nestedDataTableColumnData = (col, value) => {
            // Note that I based this function on DataTableNested render logic for cells.
            // This hopefully means it will look similar to the rest of the table.
            // If we ever change that, we may need to update this too.
            // Also note that I removed the inner DIV, as it was interfering with ability to put a border above the footer row

            return (
            <td
                key={col.key}
                className={col.className || ""}
                style={{...col.style || {}, paddingLeft: "0rem" , 
                        textAlign: col.align === "right" ? "right" : "left", 
                        fontWeight: "bold", // NOTE THAT THIS IS DIFFERENT - MAKE FOOTER BOLD
                        borderTop: "3px solid var(--text-color-muted)" // NOTE THAT THIS IS DIFFERENT - ADD TOP BORDER
                    }}
            >                    
                {col.render ? col.render(value, undefined, false, false) : value}
            </td>
        )}

        const keysToTotal = Object.keys(quoteItems[0]).filter(x => x.startsWith('total'));

        const quoteItemTotals = quoteItems.reduce((totals, item) => {
            keysToTotal.forEach(key => {
                const value = item[key];
                totals[key] = (totals[key] || 0) + (isFinite(value) ? value : 0);
            });
            return totals;
        }, {});

        return ( 
            <tr>
                {columns
                .filter(x => !x.groupHeader)
                .map((col, index) => {
                    if (index === columns.filter(x => !x.groupHeader).findLastIndex(x => x.groupColumn)) {
                        return nestedDataTableColumnData({...col, align: "right"}, "TOTAL:");
                    } else if (col.calculateTotal) {
                        return nestedDataTableColumnData(col, col.calculateTotal(quoteItemTotals));
                    } else {
                        return nestedDataTableColumnData(col, quoteItemTotals[col.key]);
                    }
                })}
            </tr>
        )
    };

    return (
        <Collapsable header={header} open fluid>
            <Row>
                <Col>
                    <DataTableNested
                        id="quote-overview-financial-table"
                        data={quoteItems}
                        columns={columns}
                        width="auto"
                        footer={generateFooter()}
                    />
                </Col>
            </Row>       
        </Collapsable>  
    );
}
export default QuoteOverviewFinancialTable;